export default "__VITE_ASSET__Bo2SmlC7__"